export default __webpack_public_path__ + "static/ct-drag-drop-b69a6656d37a65feae1b422383e153b6.mp4";